var _style, _defs, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000092450700926663291270000004179844502818047114_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000019637400306173503870000011009323585301386629_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021099041280764094790000016492336356549793982_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000021099041280764094790000016492336356549793982_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3 C7,0.4,5.9,0,4.8,0s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2 c0.8-0.8,1.2-1.9,1.2-3s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000083782971891635841650000016279785721902867386_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M62.2,28.8c1-2,1-4.3,0.2-6.3c-1.7-3.9-3.5-10.4,0.5-13.9c6-5.3,18.8,2,18.8,20S67.5,48.2,62.4,41.4 C59.2,37.1,60.7,32,62.2,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.9,32c-1-2-1-4.3-0.2-6.3c1.7-3.9,3.5-10.4-0.5-13.9c-6-5.3-18.8,2-18.8,20s14.2,19.6,19.3,12.8 C45,40.3,43.5,35.2,41.9,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.8,29.2c0,0,6.2-6.7,6.2,0s0,33.3,0,33.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.4,26.5c0,0-6.2-6.7-6.2,0s0,35.8,0,35.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.1,13.6c2,1.8,3.8,4.8,4,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M31.1,42.9c-2-1.9-3.7-4.9-3.8-8.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M71.4,75.6c0,4.9-4,9.2-9.9,11.5c-2.2,0.8-4,2.3-5,4.4L54,96.4c-0.8,1.5-2.9,1.5-3.6,0L48,91.6 c-1-2.1-2.9-3.6-5.1-4.4c-6-2.2-10-6.6-10-11.5c0-7.3,8.6-13.1,19.2-13.1S71.4,68.4,71.4,75.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrology);
export default __webpack_public_path__ + "static/media/Urology.66a870853940cbcdadf5081110b463b3.svg";
export { ForwardRef as ReactComponent };